export default function KursusIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 48}
      height={height ? height : width ? width : 48}
      viewBox="-2 -1 50 50"
    >
      <g
        transform="matrix(2,0,0,2,0,0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
      >
        <path d="M18.75,12.1V6a1.5,1.5,0,0,0-1.5-1.5h-4.5"></path>
        <path d="M6.75,4.5H2.25A1.5,1.5,0,0,0,.75,6v9a1.5,1.5,0,0,0,1.5,1.5h4.5"></path>
        <line x1="6" y1="16.5" x2="3.75" y2="21.75"></line>
        <line x1="9.75" y1="0.75" x2="9.75" y2="3"></line>
        <polygon points="16.5 14.308 9.75 17.087 16.5 19.558 23.25 17.087 16.5 14.308"></polygon>
        <line x1="9.75" y1="17.066" x2="9.75" y2="20.837"></line>
        <path d="M12.75,18.185V21.3a.749.749,0,0,0,.472.7l3,1.2a.745.745,0,0,0,.557,0l3-1.2a.748.748,0,0,0,.471-.7V18.185"></path>
        <path d="M11.25,6h-3a1.5,1.5,0,0,1-1.5-1.5h0V3.75A.75.75,0,0,1,7.5,3H12a.75.75,0,0,1,.75.75V4.5h0A1.5,1.5,0,0,1,11.25,6Z"></path>
      </g>
    </svg>
  );
}
